import React from 'react';
import './header.css';
import { Link, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom

function Header({ scrollToSection, homeRef, aboutRef, contentsRef }) {
    const navigate = useNavigate();

    // Handle navigation and scrolling
    const handleNavigation = (ref) => {
        navigate('/'); // Navigate to the home page
        setTimeout(() => {
            scrollToSection(ref); // Scroll to the specific section after navigation
        }, 100); // Add a small delay to ensure the page has loaded
    };

    return (
        <header className="header">
            <nav>
                <ul style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                }}>
                    <li><Link to="/"><img src="./logo/IAL.png" alt="logo" className="logo" /></Link></li>
                    <li>Interactive Anywhere Lab</li>
                </ul>
            </nav>

            <nav>
                <ul>
                    <li>
                        <Link
                            to="/"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default navigation
                                handleNavigation(homeRef); // Navigate and scroll to Home
                            }}
                        >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default navigation
                                handleNavigation(aboutRef); // Navigate and scroll to About
                            }}
                        >
                            About
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default navigation
                                handleNavigation(contentsRef); // Navigate and scroll to Enjoy
                            }}
                        >
                            Enjoy!
                        </Link>
                    </li>

                    {/*<li>
                        <Link to="/generatearts">
                            Simuration!
                        </Link>
                    </li>*/}
                    <li>
                        <a
                            href="https://docs.google.com/forms/d/e/1FAIpQLScclkj2NVbcbSYWIp8cseWV8iVLCUdJDkT24nJdYZzWD2hvpg/viewform"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Contact
                        </a>
                    </li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;